import axiosInstance from "./AxiosInstance";

const API_URL = "/certificate";

export const getCertificate = async (email = null) => {
  const url = email ? `${API_URL}?email=${email}` : API_URL;
  const response = await axiosInstance.get(url);
  return response.data;
};